var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRadioButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14857_48860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 1.32812C4.3187 1.32812 1.33203 4.31479 1.33203 7.99479C1.33203 11.6748 4.3187 14.6615 7.9987 14.6615C11.6787 14.6615 14.6654 11.6748 14.6654 7.99479C14.6654 4.31479 11.6787 1.32812 7.9987 1.32812ZM7.9987 13.3281C5.05203 13.3281 2.66536 10.9415 2.66536 7.99479C2.66536 5.04812 5.05203 2.66146 7.9987 2.66146C10.9454 2.66146 13.332 5.04812 13.332 7.99479C13.332 10.9415 10.9454 13.3281 7.9987 13.3281Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0013 11.3385C9.84225 11.3385 11.3346 9.84616 11.3346 8.00521C11.3346 6.16426 9.84225 4.67188 8.0013 4.67188C6.16035 4.67188 4.66797 6.16426 4.66797 8.00521C4.66797 9.84616 6.16035 11.3385 8.0013 11.3385Z",
    fill: "#667085"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14857_48860"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioButton);
export default __webpack_public_path__ + "static/media/radio-button.ce6b0f4b9667c9022e44b3646d931491.svg";
export { ForwardRef as ReactComponent };